import React, { useImperativeHandle} from 'react'
import { useFormik, FormikProvider, FieldArray } from 'formik'

// components
import InputField from '../../../components/forms/InputField/InputField.component';
import FormSectionHeader from '../../../components/forms/FormSectionHeader/FormSectionHeader.component';
import FormDataPoint from '../../../components/forms/FormDataPoint/FormDataPoint.component';
import ProcessEquipmentRequestItemInput from '../../../components/forms/lists/ProcessEquipmentRequestItemInput/ProcessEquipmentRequestItemInput.component';
import AsyncSelectField from '../../../components/forms/AsyncSelectField/AsyncSelectField.component';

// queries
import { GET_ALL_TRUCKS_FOR_SELECT_FIELD } from '../../../graphql/truck/truck.queries';

const ProcessEquipmentRequest = React.forwardRef(({ prefillData = null, stage, requestId, errors }, ref) => {
    useImperativeHandle(ref, () => ({
        getData: () => { return formik.values }
    }))

    const formik = useFormik({
        initialValues: prefillData ? {...prefillData} : {
            equipment: [],
            truck: '',
            notes: '',
        },
        onSubmit: values=> {
            alert(JSON.stringify(values, null, 2));
        },
    });

    const stage0 = (<React.Fragment>

            <FormDataPoint label='Job' value={prefillData['job'].name} />
            <FormDataPoint label='Requested By' value={prefillData ? `${prefillData['requestedBy'].firstName} ${prefillData['requestedBy'].lastName}` : null} />

            <FormSectionHeader text='Equipment' />

            <FieldArray 
                name='equipment'
                render={() => (
                    <div>
                        {
                            formik.values.equipment.map((item, index) => {
                                return (<ProcessEquipmentRequestItemInput 
                                    key={`${item.name}-{index}`}
                                    stage={stage}
                                    prefix={`equipment.${index}`}
                                    handleChange={formik.handleChange}
                                    equipmentName={item.equipment.name}
                                    requestedQuantity={item.requestedQuantity}
                                    sentQuantity={item.sentQuantity}
                                    maxQuantity={item.maxQuantity}
                                    note={item.note}
                                    errors={errors['equipment'].length > index ? errors['equipment'][index] : {}}
                                />)
                            })
                        }
                    </div>
                )}
            />
        </React.Fragment>)

    const stage1 = (<React.Fragment>

            <AsyncSelectField 
                id="truck"
                value={formik.values.truck}
                onChange={value => formik.setFieldValue('truck', value.value)}
                placeholder="Select a Truck"
                query={{
                    query: GET_ALL_TRUCKS_FOR_SELECT_FIELD,
                    rules: {
                        loopField: 'allTrucks',
                        label: ['number'],
                        value: 'id'
                    }
                }}
                isValid={errors['truck']}
            />

            <InputField 
                id="notes"
                type="textarea"
                placeholder="Notes"
                onChange={formik.handleChange}
                value={formik.values.notes}
                isValid={errors['notes']}
                required={false}
            />
            
            <FieldArray 
                name='equipment'
                render={() => (
                    <div>
                        <FormSectionHeader text='Equipment' />
                        {
                            formik.values.equipment.map((item, index) => {
                                return (<ProcessEquipmentRequestItemInput 
                                    key={`${item.name}-{index}`}
                                    stage={stage}
                                    prefix={`equipment.${index}`}
                                    handleChange={formik.handleChange}
                                    equipmentName={item.equipment.name}
                                    requestedQuantity={item.requestedQuantity}
                                    sentQuantity={item.sentQuantity}
                                    note={item.note}
                                    errors={errors['equipment'].length > index ? errors['equipment'][index] : {}}
                                />)
                            })
                        }
                    </div>
                )}
            />
        </React.Fragment>)

    return (<FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>

            { stage === 0 && stage0 }
            { stage === 1 && stage1 }
            
        </form>
    </FormikProvider>)
})

export default ProcessEquipmentRequest